module.exports = new __parcel__URL__("cornershop-iphone.cd391b81.webp").toString();